import React from 'react';
import './progressbar.css'


const Progress = ({ done }) => {
	const [style, setStyle] = React.useState({});

	setTimeout(() => {
		const newStyle = {
			opacity: 1,
			width: `${done}%`
		}

		setStyle(newStyle);
	}, 200);

	return (
		<div className="newdonation-progress">
			<div className="progress-donation">
				<div className="progress-done-donation" style={style}>
					{done}%
				</div>
			</div>
		</div>
	)
}


export default Progress;